module.exports = __webpack_public_path__ + "static/media/register-now-btn.4fd17b47.png";